import { render, staticRenderFns } from "./uiField.vue?vue&type=template&id=7ca8e730&scoped=true"
import script from "./uiField.vue?vue&type=script&lang=js"
export * from "./uiField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca8e730",
  null
  
)

export default component.exports